@let labelText = $labelText();
@if (labelText) {
  <kendo-label [text]="labelText">
    <ng-template [ngTemplateOutlet]="innerContent" />
  </kendo-label>
} @else {
  <ng-template [ngTemplateOutlet]="innerContent" />
}
<ng-template #innerContent>
  <kendo-textbox [disabled]="true">
    <ng-template kendoTextBoxPrefixTemplate>
      <span class="inline">
        <a class="k-link underline" [routerLink]="$link()">{{ $displayText() }}</a>
      </span>
    </ng-template>
  </kendo-textbox>
</ng-template>
